import { getGrid, readContentItems, readDataByContentItemIds,deleteContentItems, batchUpdateContentItems } from "../../apis/httpHelper"
import { GridEvent, FieldType, GridAction, SingleAction } from "."
import { handlerUpdateParams, qweGuid, qweIsEmpty } from "../../common/commonHelper"
import { ResponseCode } from "../../common/constant"
import { FormEvent } from "../../components/Form"
import { ElMessage, ElNotification } from 'element-plus'
import { UpdateMode } from "../../common"

var dataSourceList = {};
export default {    
    props:{
        gridId:{
            type: String
        },
        isPropMode:{
            type:Boolean,
            default:function(){
                return false
            }
        },
        propDatas:{
            type: Object
        },
        propFilter:{
            type: Object
        },
        isSingleSelect:{
            type:Boolean,
            default:function(){
                return false
            }
        }
    },

    data:function(){
        return {
            handlerOrginalFilterTag:false,
            batchAuth:false,
            requestFields:[],
            context:{
                Content:null,
                UserInfo: this.$store.state.userInfo,
                Properties:{
                    Selects:[]
                }
            },

            filterState:false,
            middleFilterDefinition:[],
            simplefilter:false,
            simpleFilterDefinition:[],

            importState:false,
            formEvent:FormEvent,
            orginaldataFilter:{},
            superImport:false,
            superImportWorkflows:[],
            orginalSort:[],

            gridName:"",
            dataSourceId:"",
            createAble:false,
            editAble:false,
            batchDelete:false,
            exportAble:false,
            importAble:false,

            excelImportState:false,
            exportExcelPath:"1",

            isFlow:false,

            pageSizes:[20,50,100],
            pageSize:20,

            selectCount:0,
            selectMap:"",

            showColumnOptions:[],

            allShowColumns:false,
            showColumns:[],
            originShowColumns:[],

            contentType:"",
            createPassingParameter:[],
            excelImportParameter:[],

            batchUpdateItems:[],
            createContentItems:[],
            printItems:[],

            formItem: {
                visibleState: false,
                operation: "",
                contentType: "",
                contentItemId: "",
                flowCurrentNodeId: "",
                title: "",
                passingParameter: []
            },

            buttonSetting:{
                "NewName": "新增",
                "DeleteName": "删除",
                "EditName": "编辑",
                "ExcelName": "导入Excel",
                "BatchDeleteName": "批量删除"
            },

            printItem:{
                visibleState:false,
                url:"",
                title:""
            },

            updateItem:{
                visibleState:false,
                correlationId:"",
                title:"",
                contentId:"",
                configOptions:{},
                propDatas:{
                    ContentType:"",
                    ContentTypeDefinition:[],
                    Data:{},
                    ComputeFlowDefinition:false,
                    FlowDefinition:[]
                }
            },

            createOtherItem: {
                visibleState: false,
                operation: "Create",
                contentType: "",
                title: "",
                passingParameter: []
            },

            exportItem:{
                sort:[],
                filter:{},
                orginaldataFilter:{},
                excelExportState:false,
                exportFields:[],
            },

            auditTrailItem:{
                state:false,
                contentItemId:""
            },

            filterLoading:false,
        }
    },

    emits:[
        GridEvent.initGrid,
        GridEvent.selectChange
    ],

    created:function(){
        if(!qweIsEmpty(this.gridId)){
            this.initGrid(this.gridId);
        }
    },

    computed:{
        showToolBar:function(){
            return !this.isPropMode;
        },

        filterLoaclKey:function(){
            return this.gridId + "-filter";
        },

        showFieldLocalKey:function(){
            return this.gridId + "-showfield"
        },

        noDetailUpdateItems:function(){
            return this.batchUpdateItems.filter(x=> !x.DetailOnly);
        },

        noDetailPrintItems:function(){
            return this.printItems.filter(x=> !x.DetailOnly);
        },

        noDetailCreateItems:function(){
            return this.createContentItems.filter(x=> !x.DetailOnly);
        },

        detailPrintItems:function(){
            return this.printItems.filter(x=> x.DetailOnly);
        },

        detailItems:function(){
            let detailOptions = new Array(); 
            let detailUpdate = this.batchUpdateItems.filter(x=> x.DetailOnly);

            detailUpdate.forEach(x=> x.Type = GridAction.BatchUpdate);
            let detailCreate = this.createContentItems.filter(x=> x.DetailOnly);

            detailCreate.forEach(x=> x.Type = GridAction.BatchCreate);
            detailOptions = detailUpdate.concat(detailCreate);

            return detailOptions;
        },

        onlyOneItems:function(){
            let detailOptions = new Array();

            let detailUpdate = this.batchUpdateItems.filter(x=> x.OnlyOne);
            detailUpdate.forEach(x=> x.Type = GridAction.BatchUpdate);

            let detailCreate = this.createContentItems.filter(x=> x.OnlyOne);
            detailCreate.forEach(x=> x.Type = GridAction.BatchCreate);

            let detailPrint = this.printItems.filter(x=> x.OnlyOne);
            detailPrint.forEach(x=> x.Type = GridAction.BatchPrint);

            detailOptions = detailUpdate.concat(detailCreate).concat(detailPrint);

            return detailOptions;
        },

        isAdmin:function(){
            return this.$store.state.userInfo.IsSuperAdmin
        }
    },

    selectMapFuc:{},

    methods:{
        //初始化grid
        initGrid:function(gridId){
            getGrid(gridId).then(x=>{
                let result = x.Result;
                this.$store.commit("SetUserInfo",result.UserInfo);
                this.context.UserInfo = result.UserInfo;

                this.buttonSetting = result.ButtonSetting;
                this.contentType = result.ContentType;
                this.dataSourceId = qweGuid();
                this.gridName =result.GridName;
                this.createAble = result.User.Create;
                this.editAble = result.User.Edit;
                this.batchDelete = result.User.BatchDelete;
                this.exportAble = result.User.ExportExcel;
                this.importAble = result.User.ImportByExcel;
                this.superImport = result.IsSuperImport;
                this.superImportWorkflows = result.SuperImportWorkflows;

                this.createPassingParameter = this.handlerPassingParameter(result.PassingParameter);
                this.excelImportParameter = this.createPassingParameter.map(x=> { return { "FieldName":x.Name, "Value":x.Value, "UpdateMode":x.UpdateMode }});
                this.exportExcelPath = result.ExportExcelPath;                 

                this.isFlow = result.IsFlow;

                this.pageSizes = result.PageSizes || [20, 50, 100];
                this.pageSize = this.pageSizes.length > 0 ? this.pageSizes[0] : 20;

                result.BatchPrint.forEach(x=>{
                    x.CheckItems.forEach(checkin=>checkin.CanExe = new Function("Context", "Selects", checkin.JsScript))
                });
                result.BatchUpdate.forEach(x=>{
                    x.CheckItems.forEach(checkin=>checkin.CanExe = new Function("Context", "Selects", checkin.JsScript));
                    x.SubmitCheckItems.forEach(checkin=>checkin.CanExe = new Function("Context", "Selects", checkin.JsScript));
                });
                result.CreateContents.forEach(x=>{
                    x.CheckItems.forEach(checkin=>checkin.CanExe = new Function("Context", "Selects", checkin.JsScript))
                });

                this.exportItem.exportFields = result.Field.filter(x=> !x.Hidden);

                this.printItems = result.BatchPrint;
                this.batchUpdateItems =  result.BatchUpdate;
                this.batchUpdateItems.forEach(x=>{
                    x.Loading = false;
                });

                this.createContentItems =  result.CreateContents;
                this.createContentItems.forEach(x=>{
                    x.Loading = false;
                });
                
                this.selectMapFuc = new Function("Context", "Selects", result.SelectMap);

                let middleFields = result.Field.filter(x=> !x.Hidden).map(x=>x.Name);
                this.middleFilterDefinition = result.FieldDefinitions.filter(x=> middleFields.includes(x.Name));

                //支持过滤创建时间
                if(result.ShowMeta){
                    this.middleFilterDefinition.push({"FieldDefinition":{"Name":"DateField"},"PartDefinition":null,"Name":"CreatedUtc","Settings":{"ContentPartFieldSettings":{"DisplayName":"创建日期","Position":""},"ContentIndexSettings":{},"FieldCommonSetting":{"Required":false,"IsDisplay":true,"IsEdit":true,"Updateable":true,"IsImport":false,"Hint":null,"Width":12,"ClassNames":[],"LabelShow":true,"Fields":[]},"FieldValueSetting":{"DefaultValueType":0,"RelySetting":{"FilterSettings":[]},"Script":"","RelyFields":[]},"DateFieldSetting":{"DisplayTypeValue":1}}});
                }
                
                let simpleFields = result.Field.filter(x=> x.Filter).map(x=>x.Name);
                if(simpleFields.length > 0){
                    this.simpleFilterDefinition = result.FieldDefinitions.filter(x=> simpleFields.includes(x.Name));
                    this.simplefilter = true;
                }

                this.batchAuth = this.batchDelete || this.batchUpdateItems.length > 0 || this.createContentItems.length > 0 || this.printItems.length > 0;
                
                this.requestFields = Array.from(new Set(result.Field.map(x => x.Name)));
                //处理初始filter
                this.buildOrginalFilter(result);

                //处理初始sort
                this.orginalSort = (result.Sort || []).map(
                    x=> {
                        return {
                            field:x.Field,
                            dir:x.Dir == 0 ? "asc" : "desc"
                        }
                    }
                );

                this.handlerShowColumns(result);

                this.initKendoGrid(result);
            }).catch(x=>{
                console.log(x);
                this.$emit(GridEvent.initGrid, x.Code);
            })
        },

        //初始化kendoGrid
        initKendoGrid:async function(definition){
            let gridButtons = definition.GridButtons;
            let newGridButtons = definition.NewGridButtons || [];
            let qweSingleRowCommands = new Array;
            let that = this;
            
            //处理打印按钮
            gridButtons.forEach((x) => {
                let code = {
                    name: x.ButtonName,
                    visible: new Function("dataItem", "let Content = dataItem;" + x.Visible),
                    click: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        let tr = $(e.target).closest("tr");
                        let data = this.dataItem(tr);
                        let trId = data.ContentItemId;
                        if(x.IsDrawerShow){
                            that.printItem.title = x.ButtonName;
                            that.printItem.url = x.Url + trId;
                            that.printItem.visibleState = true;
                        }else{
                            window.open(x.Url + trId, "_blank");
                        }
                    }
                };
                qweSingleRowCommands.push(code);
            });

            newGridButtons.forEach(x=>{
                let code = {
                    name: x.ButtonName,
                    visible: new Function("dataItem", "let Content = dataItem;" + x.Visible),
                    click: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        let tr = $(e.target).closest("tr");
                        let data = this.dataItem(tr);
                        let trId = data.ContentItemId;
                        that.singleAction(x, trId);
                    }
                };
                qweSingleRowCommands.push(code);
            })

            let fields = definition.Field;
            let columns = new Array;
            let fieldModel = {};

            if(this.isPropMode){
                if(this.isSingleSelect){
                    let selectCommand = [{
                        name:"singleSelect",
                        template:'<input type="radio" class="k-grid-singleSelect cursor-pointer" title="单行选择" name="radioLineSelector"/>', 
                        click:function(e){
                            e.stopPropagation();
                            var tr = $(e.target).closest("tr");
                            this.clearSelection();
                            this.select(tr);
                            this.trigger("change");
                        }
                    }];
                    columns.push({ 
                        command:selectCommand,
                        width: 38 
                    });
                }
                else{
                    columns.push({ selectable: true, width: 38 });
                }
            }
            else{
                if(this.batchAuth){
                    columns.push({ selectable: true, width: 38 });
                }
            }


            let nodeObject = {};
            definition.Nodes.forEach(x => {
                nodeObject[x.Value] = x.Text;
            });

            let showColumnOptions = new Array();
            let localStrogeShowFields = localStorage.getItem(this.showFieldLocalKey);
            //处理grid列的显隐设置
            if (localStrogeShowFields != null) {
                this.showColumns = localStrogeShowFields.split(",");
            }
            else{
                this.showColumns = fields.filter(x=> !x.Hidden).map(x=> x.Name);
            }

            for (let i = 0; i < fields.length; i++) {
                let item = fields[i];           
                if (!item.Hidden) {
                    showColumnOptions.push({ "displayName": item.DisplayName, "name": item.Name, "type": item.Type });
                    columns.push(await this.columnsConvert(item, definition.IsUseWidth, localStrogeShowFields != null));
                }
                let jieguo = this.fieldtypeConvert(item);
                if (jieguo != null) {
                    fieldModel[item.Name] = jieguo;
                }
            };

            this.showColumnOptions = showColumnOptions;

            //流程内容项添加节点，状态展示
            if (definition.IsFlow) {
                let currentNodeIds = {
                    field: "CurrentNodeIds",
                    title: "当前流程节点",
                    template: function (dataItem) {
                        let map = new Set(dataItem.CurrentNodeIds);
                        let value = Array.from(map).map(x => nodeObject[x]);
                        return value.join("、");
                    },
                    sortable:false
                };
                let flowState = {
                    field: "FlowState",
                    title: "流程状态",
                    template: function (dataItem) {
                        var value = dataItem["FlowState"];
                        if (value == 1) {
                            return '<span class="label label-success">流程结束</span>'
                        }
                        
                        else {
                            return '<span class="label label-info">流程进行中</span>'
                        }
                    },
                    sortable:false
                }
                if (definition.IsUseWidth) {
                    currentNodeIds.width = 100;
                    currentNodeIds.locked = true;
                    flowState.width = 100;
                    flowState.locked = true;
                }
                columns.push(currentNodeIds);
                columns.push(flowState);
                fieldModel["FlowState"] = { "type": "string" }
            }

            if(definition.ShowMeta){
                columns.push({
                    field: "CreatedUtc",
                    title: "创建日期",
                    format: "{0:yyyy/MM/dd HH:mm:ss}",
                    width:146
                });
            }
            
            fieldModel["CreatedUtc"] = { "type": "date" };
            if (this.editAble || definition.GridButtons.length >0 || this.isAdmin) {
                let command = qweSingleRowCommands;
                if(definition.DailyRecord || this.isAdmin){
                    command.unshift({
                        name:"数据日志",
                        click:function(e){
                            e.preventDefault();
                            e.stopPropagation();
                            var tr = $(e.target).closest("tr");
                            var data = this.dataItem(tr);
                            var trId = data.ContentItemId;
                            that.auditTrail(trId);
                        }
                    })
                }
                if (this.editAble) {
                    command.unshift({
                        name: this.buttonSetting.EditName,
                        click(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            var tr = $(e.target).closest("tr");
                            var data = this.dataItem(tr);
                            var trId = data.ContentItemId;
                            that.editItem(trId);
                        }
                    })
                }
                let commandResult = {
                    "command": command,
                    "title": "操作"
                };
                if (definition.IsUseWidth) {
                    let ZongZiShu = qweSingleRowCommands.map(x=> x.name);
                    commandResult.locked = true;
                    let width = ZongZiShu.join(",").length * 16 + ZongZiShu.length * 30 + 20;
                    width = width > 250 ? 250 : width;
                    commandResult.width = width;
                }
                if(!this.isPropMode){
                    columns.push(commandResult);
                }
            }

            
            let handlerOrginalFilterTag = this.checkEffectiveFilter(this.orginaldataFilter);
            let allfilter = this.orginaldataFilter;
            
            this.$nextTick(function () {
                let dataSource = new kendo.data.DataSource({
                    transport: {
                        read: function(options) {
                            let data = options.data;
                            let filter = {};
                            if(handlerOrginalFilterTag){
                                filter = { 
                                    logic:"and",
                                    filters:[allfilter]
                                }
                                if(that.checkEffectiveFilter(data.filter)){
                                    filter.filters.push(data.filter);
                                }
                            }
                            else{
                                filter = data.filter;
                            }

                            readContentItems(
                                that.contentType,
                                that.requestFields,
                                data.skip,
                                data.take,
                                data.sort,
                                filter,
                                true
                            )
                            .then(x=>
                                options.success(x.Result)
                            ).catch(x=>{
                                console.log(x)
                            })
                        }
                    },
                    schema: {
                        data: "data",
                        total: "total",
                        model: {
                            id: "ContentItemId",
                            fields: fieldModel
                        }
                    },
                    pageSize: that.pageSize,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true
                });

                let definitionSort = (definition.Sort || []).map(
                    x=> {
                        return {
                            field:x.Field,
                            dir:x.Dir == 0 ? "asc" : "desc"
                        }
                    }
                );
                
                if(definitionSort.length>0){
                    dataSource.sort(definitionSort);
                }
                
                dataSourceList[that.dataSourceId] = dataSource;

                let filterItem = this.$el.getElementsByClassName("simplefilter")[0].offsetHeight;
                let headToolItems = this.$el.getElementsByClassName("headTool")
                let headTool = (headToolItems[0].offsetHeight + 15) * headToolItems.length;
                let gridItem = $(this.$el)[0].offsetHeight;

                let bodyHeight = gridItem - headTool - filterItem;
                
                let gridConfig = {
                    dataSource: dataSourceList[that.dataSourceId],
                    columnResizeHandleWidth: 5,
                    resizable: true,
                    sortable: {
                        showIndexes: true,
                        mode: "multiple"
                    },
                    pageable:{
                        numeric: true,
                        buttonCount: 5,
                        pageSizes: that.pageSizes
                    },
                    height: bodyHeight + "px",
                    columns: columns,
                    change: function (e) {
                        let selectedCount = this.selectedKeyNames().length;
                        that.selectCount = selectedCount;
                        if(selectedCount>0){
                            that.getSelectItems().then(x=>{
                                let selectItems = x.Result.data;  
                                that.$emit(GridEvent.selectChange, selectItems);
                                let result = that.selectMapFuc(null, selectItems);
                                that.selectMap = result != '' ? "," + result : result; 
                            });
                        }
                        else{
                            that.selectMap = "";
                            that.$emit(GridEvent.selectChange, []);
                        }
                    }
                };
                if(this.isPropMode && this.isSingleSelect){
                    gridConfig.selectable = true;
                }

                $(this.$refs.grid).kendoGrid(gridConfig);
                this.$emit(GridEvent.initGrid, 200, definition);
                if(this.isPropMode && this.isSingleSelect){
                    let timer = setInterval(()=>{
                        console.log("多次打印为内存泄漏");
                        let kSelectableTable = this.$el.querySelector(".k-grid-content table");
                        if(kSelectableTable != null){
                            clearInterval(timer);
                            kSelectableTable.className = "k-selectable1"
                        }
                    },500)
                }
            })
        },

        // 构建原始过滤器
        buildOrginalFilter:function(definition){
            let dataFilterFuc = new Function("Context", definition.FilterString);
            let gridFilterData = dataFilterFuc(this.context);
            let propFilterData = this.propDatas;
            let allfilter = {};

            if(this.isPropMode){
                let gridFilterTag = this.checkEffectiveFilter(gridFilterData);
                if(this.checkEffectiveFilter(propFilterData)){
                    if(gridFilterTag){
                        allfilter = { "logic" :"and","filters":[gridFilterData, propFilterData]}
                    }
                    else{
                        allfilter = propFilterData;
                    }
                }
                else{
                    allfilter = gridFilterData;
                }   
            }
            else{
                if(this.checkEffectiveFilter(this.propFilter)){
                    allfilter = { "logic" :"and","filters":[gridFilterData, this.propFilter]}
                }
                else{
                    allfilter = gridFilterData;
                }
            }

            this.handlerOrginalFilterTag = this.checkEffectiveFilter(allfilter);
            this.orginaldataFilter = allfilter;

        },

        // 显示列
        handlerShowColumns:function(result){
            let fields = result.Field;
            let localStrogeShowFields = localStorage.getItem(this.showFieldLocalKey);
            if (localStrogeShowFields != null) {
                this.showColumns = localStrogeShowFields.split(",");
            }
            else{
                this.showColumns = fields.filter(x=> !x.Hidden).map(x=> x.Name);
            }

            for (let i = 0; i < fields.length; i++) {
                let item = fields[i];           
                if (!item.Hidden) {
                    this.showColumnOptions.push({ "displayName": item.DisplayName, "name": item.Name, "type": item.Type });
                }
            };
        },

        // 列转换
        columnsConvert:async function (item, isUseWidth, handlerHidden) {
            let result = {};
            let that = this;

            if(item.Type == "LinkContentItemField"){
                let buttonName = this.middleFilterDefinition.find(x=>x.Name == item.Name)?.Settings.LinkContentItemFieldSetting.ButtonName;
                let linkContentItemFieldCommand = [{
                    name:"LinkContentItemField",
                    text:buttonName,
                    click:function(e){
                        e.preventDefault();
                        e.stopPropagation();
                        var tr = $(e.target).closest("tr");
                        var data = this.dataItem(tr);
                        var trId = data[item.Name];
                        that.editItem(trId);
                    }
                }];
                result = { 
                    command:linkContentItemFieldCommand,
                    title:"操作"
                };
            }

            else{
                switch (item.Type) {
                    case "TextField":
                        result = {
                            field: item.Name,
                            title: item.DisplayName
                        };
                        break;
                    case "BooleanField":
                        result = {
                            field: item.Name,
                            title: item.DisplayName,
                            template: function (dataItem) {
                                let value = dataItem[item.Name];
                                if (value != null) {
                                    if (value) {
                                        return "是";
                                    }
                                    else {
                                        return "否";
                                    }
                                }
                                return value;
                            }
                        };
                        break;
                    case "DateField":
                        result = {
                            field: item.Name,
                            title: item.DisplayName,
                            format: "{0:yyyy/MM/dd}"
                        };
                        break;
                    case "AttachFileField":
                    case "ImageField":
                        result = {
                            field: item.Name,
                            title: item.DisplayName,
                            enabled: false,
                            template: function (dataItem) {
                                let value = dataItem[item.Name] || [];
                                return "<div class='grid-fujian'>" +value.map((x, index) => {
                                    return "<a href='" + x.Url + "' target='_blank'>附件" + (index+1) + "</a>"
                                }).join("") +"</div>";
                            }
                        };
                        break;
                    case "SingleDepartField":
                        result = {
                            field: item.Name + ".DepartName",
                            title: item.DisplayName
                        };
                        break;
                    case "SingleUserField":
                        result = {
                            field: item.Name + ".NickName",
                            title: item.DisplayName
                        };
                        break;
                    case "DepartField":
                        result = {
                            title: item.DisplayName,
                            template: function (dataItem) {
                                let value = dataItem[item.Name] || [];
                                return value.map(x=>x.DepartName).join(",");
                            }
                        };
                        break;
                    case "UserField":
                        result = {
                            title: item.DisplayName,
                            template: function (dataItem) {
                                let value = dataItem[item.Name] || [];
                                return value.map(x=>x.NickName).join(",");
                            }
                        };
                        break;
                    case "MultChoiceProField":
                        result = {
                            field: item.Name,
                            title: item.DisplayName,
                            template: function (dataItem) {
                                let value = dataItem[item.Name];
                                return (value || []).join(",");
                            }
                        };
                        break;
                    case "PositionField":
                        result = {
                            field: item.Name,
                            title: item.DisplayName,
                            template: function (dataItem) {
                                let value = dataItem[item.Name] || {Cascader: [], Detail: ""};
                                return value.Cascader.join("") + value.Detail
                            }
                        };
                        break;
                    
                    default:
                        result = {
                            field: item.Name,
                            title: item.DisplayName
                        };
                        break;
                }
                if((item.DataSource != undefined || item.DataSource != null) 
                    && !(qweIsEmpty(item.DataSource.ContentType) || qweIsEmpty(item.DataSource.Label) || qweIsEmpty(item.DataSource.Value))){
                    result.values = await this.newDataSource(item.DataSource);
                }
                if (item.Template !== null) {
                    let context = {
                        Content:{},
                        UserInfo: this.$store.state.userInfo,
                        Properties:{}
                    };
                    result.template = function(dataItem){
                        let func = new Function("Context","Content","dataItem", item.Template);
                        context.Content = dataItem;
                        return func(context, dataItem, dataItem);
                    }
                }
                if (!item.Sort) {
                    result.sortable = false;
                }
                result.filter = true;
                
                if (handlerHidden) {
                    result.hidden = this.showColumns.findIndex(x => x == item.Name) == -1;
                }
                result.filterable = true;
            }
            if (isUseWidth) {
                result.width = item.Width;
            }
            return result;
        },

        // 字段类型转换
        fieldtypeConvert: function (item) {
            return {
                type:FieldType[item.Type]
            };
        },

        // 新建
        newItem: function () {
            if(!this.createAble) {
                return;
            }
            this.formItem.operation = "Create";
            this.formItem.contentType = this.contentType;
            this.formItem.visibleState = true;
            this.formItem.passingParameter = this.createPassingParameter;
        },

        //编辑
        editItem: function (contentItemId) {
            if(!this.editAble) {
                return;
            }
            this.formItem.operation = "Edit";
            this.formItem.contentItemId = contentItemId;
            this.formItem.visibleState = true;
        },

        //表单初始化回调
        fromInit: function (code, formBuilder){
            if (code === ResponseCode.Success) {
                this.formItem.title = formBuilder.CurrentDisplayName;
            }
            else if(code == ResponseCode.UnAuthoized){
                this.formItem.visibleState = false;
                ElMessage.error("无权限")
            }
            else{
                this.formItem.visibleState = false;
            }
        },

        //表单提交回调
        formSubmit:function(operator, code, formInstance){
            if(operator !=  FormEvent.draft){
                if(code == ResponseCode.Success || code == ResponseCode.SuccessAndWarn){
                    this[formInstance].visibleState = false;
                    //this.createOtherItem.visibleState = false;
                    this.fetchDataSource();
                }
            }
        },

        //批量更新操作，根据情况区分，打开表单式跟静默提交
        batchUpdateContentItems:function(item, context){
            this.updateItem.correlationId = context;
            this.getSelectItems(context).then(x=>{
                let selectItems = x.Result.data;
                this.context.Properties.Selects = selectItems;
                if(this.batchCheckItems(item.CheckItems, this.context)){
                    //打开表单式
                    if(item.ShowModal){
                        this.updateItem.contentId = item.ContentId;
                        this.updateItem.configOptions = item;
                        this.updateItem.title = item.ButtonName;

                        this.updateItem.propDatas.ContentType = this.contentType;
                        this.updateItem.propDatas.ContentTypeDefinition = item.Defitions;
                        
                        let Data = {};

                        //转化field格式至form
                        item.BatchFields.forEach(x=> {
                            x.Name = x.FieldName;
                        });

                        item.BatchFields.forEach(x=>{
                            if(x.UpdateMode == UpdateMode.FrontFormula){
                                Data[x.FieldName] = (new Function("Context", "Selects", x.Value))(this.context, selectItems);
                            }
                            else if(x.UpdateMode == UpdateMode.Value){
                                Data[x.FieldName] = x.Value;
                                if(x.Value == null){
                                    if(selectItems.length == 1){
                                        Data[x.FieldName] = selectItems[0][x.FieldName]
                                    }
                                }
                            }
                        });

                        this.updateItem.propDatas.Data = Data;
                        this.updateItem.propDatas.FlowDefinition = item.BatchFields;
                        this.updateItem.visibleState = true;
                    }
                    //静默提交
                    else{
                        let contentItemIds = this.getContentItemIds(context);
                        let request = new Array();
                        item.BatchFields.forEach(x=>{
                            let field = {
                                FieldName: x.FieldName,
                                UpdateMode: x.UpdateMode,
                                Value :x.Value
                            }
                            if(x.UpdateMode == UpdateMode.FrontFormula){
                                field.UpdateMode = UpdateMode.Value;
                                field.Value = (new Function("Context", "Selects", x.Value))(this.context, selectItems);
                            }
                            request.push(field);
                        });
                        
                        let notice = '将对 <span style="color:rgb(245, 108, 108)">' + contentItemIds.length + '</span> 条数据执行 <span style="color:rgb(245, 108, 108)">'+ item.ButtonName +'</span> 操作, 是否继续?';
                        if(!qweIsEmpty(context)){
                            notice = '将对当前数据执行 <span style="color:rgb(245, 108, 108)">'+ item.ButtonName +'</span> 操作, 是否继续?'
                        }

                        this.$confirm(
                            notice, 
                            item.ButtonName,
                            {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            dangerouslyUseHTMLString: true,
                            type: 'warning'
                        }).then(()=>
                            {
                                item.Loading = true;
                                batchUpdateContentItems(contentItemIds,request).then(response=>{
                                    this.batchUpdateContentItemResponse(response, item);
                                    this.fetchDataSource();
                                }).catch(x=>{
                                    console.log(x);
                                }).finally(()=>{
                                    item.Loading = false;
                                })
                            }
                            
                        ).catch(()=>{})
                        
                    }
                }
            });
        },

        //批量更新前操作，校验数据，提交更新
        updateBeforeSubmit: function(self, operator){
            let data = self.formData;
            let ids = this.getContentItemIds(this.updateItem.correlationId); 
            let updateOptions = this.updateItem.configOptions;
            let fieldDiv = updateOptions.Defitions.map(x=> {
                return '<span class="el-tag el-tag--success">' +x.Settings.ContentPartFieldSettings.DisplayName+"</span>"
            }).join("");
            let that = this;
            let notice = '<p class="el-message-box__title" style="padding:0 15px">你确定要修改所选数据吗？</p>'
                +'<div class="el-message-box__content">将对 <span style="color:rgb(245, 108, 108)">' + ids.length 
                + '</span> 条数据执行修改操作<br>数据修改后不可恢复，请谨慎操作<div>';

            let result = new Promise((resolve, reject)=>{
                this.$confirm(
                    notice, 
                    "",
                    {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        customClass:"batchChangeFieldMessageBox",
                        showClose:false,
                        type: 'warning'
                    }
                ).then(()=>{
                    if(updateOptions.ShowModal){
                        return that.getSelectItems(that.updateItem.correlationId);
                    }
                    else{
                        reject();
                    }
                }).then((selectItemsResponse) =>{
                        let selectItems = selectItemsResponse.Result.data;
                        that.context.Properties.Selects = selectItems;
                        that.context.Content = data;
                        let request = new Array();
                        updateOptions.BatchFields.forEach(x=>{
                            let field = {
                                FieldName: x.FieldName,
                                UpdateMode: x.UpdateMode,
                                Value :x.Value
                            }
                            if(x.UpdateMode != UpdateMode.Formula){
                                field.Value = data[x.FieldName];
                            }
                            if(x.Updateable){
                                request.push(field);
                            }
                        });
                        if(this.batchCheckItems(updateOptions.SubmitCheckItems, this.context)){
                            batchUpdateContentItems(ids, request).then(response=>
                            {
                                that.batchUpdateContentItemResponse(response, updateOptions);   
                                that.updateItem.visibleState = false;
                                that.fetchDataSource();
                                resolve();
                            }).catch(x=>{
                                reject(x);
                            })
                        }
                        else{
                            console.log("batchCheckItems验证不通过");
                            reject();
                        }
                })
                .catch(()=>{
                    reject();
                })
            })
            return result;
        },
        
        //批量更新后接收响应操作回调
        batchUpdateContentItemResponse:function(response, updateOptions){
            if(response.Result.Success == 0){
                ElMessage.error(updateOptions.ButtonName + "全部失败，详细原因见右侧弹框");
                let message = "<div>" + response.Result.Errors.map(x=> x.ErrorMessage).join("<br />")+ "</div>";
                ElNotification({
                    title: '失败详情',
                    message: message,
                    dangerouslyUseHTMLString: true,
                    type: 'error',
                    duration: 0
                })
            }else{
                if(response.Result.Errors.length == 0){
                    ElMessage.success(updateOptions.ButtonName + "全部成功");
                }
                else{
                    ElMessage.warning({
                        message: updateOptions.ButtonName + "成功" + response.Result.Success + "条数据" + "，" + response.Result.Errors.length + "条数据失败，失败详细原因见右侧弹框",
                        duration: 5000
                    });
                    let message = "<div>" + response.Result.Errors.map(x=> x.ErrorMessage).join("<br />")+ "</div>";
                    ElNotification({
                        title: '失败详情',
                        message: message,
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        duration: 0
                    })
                }
            }
        },

        //批量创建内容项
        batchCreateContentItems:function(item, context){
            this.getSelectItems(context)
                .then(x=>{
                    let selectItems = x.Result.data;
                    this.context.Properties.Selects = selectItems;
                    if(this.batchCheckItems(item.CheckItems, this.context)){
                        this.createOtherItem.title = item.ButtonName;
                        this.createOtherItem.operation = "Create";
                        this.createOtherItem.contentType = item.ContentType;
                        
                        this.createOtherItem.passingParameter = this.handlerPassingParameter(item.BatchFields, [{ "Key":"Selects", "Value": selectItems}]);
                        this.createOtherItem.visibleState = true;
                    }
                })
        },

        //批量打印内容项
        batchPrint:function(item,  context){
            this.getSelectItems(context).then(x=>{
                let selectItems = x.Result.data;
            
                this.context.Properties.Selects = selectItems;
                if (this.batchCheckItems(item.CheckItems,this.context)) {
                    let selectedIds = this.getContentItemIds(context);
                    let Url = this.$store.state.baseUrl + "/Qwe.ContentFlow.Print/Print/BatchPrintIndex";
                    let batchField = this.handlerPassingParameter(item.BatchFields);
                    var data = {};
                    batchField.forEach(x => {
                        data[x.Name] = x.Value;
                    });
                    let result = new Array;
                    result.push({ "name": "TemplateId", "value": item.Url });
                    result.push({ "name": "DataIds", "value": selectedIds });
                    result.push({ "name": "JsonModel", "value": JSON.stringify(data) });
                    this.postSubmit(Url, result);
                }
            });
        },

        // 更新提交表单
        updateSubmitForm:function(operator, code){
            // if(code == ResponseCode.Success || code == ResponseCode.SuccessAndWarn){
            //     this.updateItem.dialogVisible = false;
            //     this.fetchDataSource();
            // }
        },

        // 复制显示列
        copyShowColumns:function(){
            this.originShowColumns = this.showColumns.concat();
        },

        // 处理显示列变化
        handlerShowColumnOfChange:function(){
            let hidden = this.originShowColumns.filter(x => this.showColumns.findIndex(y => y == x) == -1);
            let show = this.showColumns.filter(x => this.originShowColumns.findIndex(y => y == x) == -1);
            localStorage.setItem(this.showFieldLocalKey, this.showColumns.join(","));

            let grid = $(this.$refs.grid).data("kendoGrid");
            hidden.forEach(x => {
                grid.hideColumn(x);
            });
            show.forEach(x => {
                grid.showColumn(x);
            });

            localStorage.setItem(this.showFieldLocalKey, this.showColumns.join(","))
        },

        // 处理传递参数，包括新增数据，批量打印，批量创建数据
        handlerPassingParameter: function (Parameter, passParams) {
            return handlerUpdateParams(Parameter, this.context, passParams);
        },

        // 删除内容项
        deleteItems:function(){
            let contentItemIds = this.getContentItemIds();
            if(contentItemIds.length == 0){
                ElMessage.error("当前未选中任何数据");
            } 
            else{
                this.$confirm('将对 <span style="color:rgb(245, 108, 108)">' + contentItemIds.length + '</span> 条数据执行 <span style="color:rgb(245, 108, 108)">删除</span> 操作, 是否继续?', '删除提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        type: 'warning'
                    }).then(()=>
                        deleteContentItems(contentItemIds).then(x=>{
                            ElMessage.success("删除成功" + x.Result + "条数据");
                            this.fetchDataSource();
                        }).catch(x=>{
                            console.log(x);
                        })
                    ).catch(()=>{})
            }
        },

        // 获取选中内容项ID
        getContentItemIds: function (context) {
            if(context == undefined){
                let grid = $(this.$refs.grid).data("kendoGrid");
                return grid.selectedKeyNames();
            }
            else{
                return [context];
            }
        },

        // 获取选中内容项
        getSelectItems: function(context){
            var itemIds = [];
            if(context == undefined){
                let grid = $(this.$refs.grid).data("kendoGrid");
                itemIds = grid.selectedKeyNames();
            }
            else{
                itemIds = [context];
            }
            return readDataByContentItemIds(itemIds, this.requestFields);
        },

        // 模拟提交表单
        postSubmit:function(URL, PARAMTERS) {
            //创建form表单
            var temp_form = document.createElement("form");
            temp_form.action = URL;
            //如需打开新窗口，form的target属性要设置为'_blank'
            temp_form.target = "_blank";
            temp_form.method = "post";
            temp_form.style.display = "none";
            //添加参数
            for(var item in PARAMTERS) {
                var opt = document.createElement("textarea");
                opt.name = PARAMTERS[item].name;
                opt.value = PARAMTERS[item].value;
                temp_form.appendChild(opt);
            }
            let requestVerificationToken = document.createElement("input");
            requestVerificationToken.name = '__RequestVerificationToken';
            requestVerificationToken.value = $("input[name=__RequestVerificationToken]").val();
            temp_form.appendChild(requestVerificationToken);
            document.body.appendChild(temp_form);
            //提交数据
            temp_form.submit();
            //移除提交
            temp_form.remove();
        },

        checkEffectiveFilter:function(dataFilterData){
            let handlerOrginalFilterTag = true;
            if (dataFilterData == undefined || dataFilterData == null) {
                handlerOrginalFilterTag = false;
            }
            else {
                if (dataFilterData.constructor === Object) {
                    if ((dataFilterData.hasOwnProperty("logic") && dataFilterData.hasOwnProperty("filters"))
                        || (dataFilterData.hasOwnProperty("field") && dataFilterData.hasOwnProperty("operator") && dataFilterData.hasOwnProperty("value"))) {
                        handlerOrginalFilterTag = true;
                    }
                    else {
                        handlerOrginalFilterTag = false;
                    }
                }
                else {
                    handlerOrginalFilterTag = false;
                }
            }
            return handlerOrginalFilterTag;
        },

        // 刷新数据
        fetchDataSource: function () {
            dataSourceList[this.dataSourceId].fetch();
            this.selectCount = 0;
            this.selectMap = "";
        },

        // 检测批量数据是否满足条件
        batchCheckItems: function (checkIn, context) {
            if (context.Properties.Selects.length == 0) {
                ElMessage.error('未选中任何数据');
                return false;
            }
            let notice = new Array();
            checkIn.forEach(x => {
                if (!x.CanExe(context, context.Properties.Selects)) {
                    notice.push(x.Notice);
                }
            });
            if (notice.length > 0) {
                notice.forEach(x => {
                    setTimeout(function () {
                        ElMessage.error(x);
                    }, 50);
                });
                return false;
            }
            return true;
        },

        // 初始化导入数据回调
        initImport:function(code){
            if(!code){
                ElMessage.error("系统异常，稍等一会再试");
                this.excelImportState = false;
            }
        },


        // 完成导入数据回调
        finishImport:function(){
            this.excelImportState = false;
            this.fetchDataSource();
        },

        // 导出数据按钮事件
        excelExport:function(){
            this.exportItem.orginaldataFilter = this.orginaldataFilter;
            this.exportItem.filter = dataSourceList[this.dataSourceId].filter();
            this.exportItem.sort = dataSourceList[this.dataSourceId].sort();
            this.exportItem.excelExportState = true;
        },

        // 清除选中
        clearSelects:function(){
            let grid = $(this.$refs.grid).data("kendoGrid");
            grid.clearSelection();
            if(this.isPropMode && this.isSingleSelect){
                this.$refs.grid.getElementsByClassName("k-grid-singleSelect").forEach(x=>x.checked=false);
                grid.trigger("change");
            }
        },

        // 重置过滤器
        resetfilter:function(){
            dataSourceList[this.dataSourceId].filter({});
            this.filterLoading = false;
        },

        // 获取过滤器
        getfilter:function(){
            return dataSourceList[this.dataSourceId].filter();
        },

        // 过滤器查询
        queryFilter:function(filter){
            this.filterLoading = true;
            dataSourceList[this.dataSourceId].filter(filter);
            this.filterState = false;
        },

        // 简单过滤器查询
        querySimpleFilter:function(filter){
            dataSourceList[this.dataSourceId].filter(filter);
        },

        // 审计追踪
        auditTrail:function(contentItemId){
            this.auditTrailItem.contentItemId = contentItemId;
            this.auditTrailItem.state = true;
        },

        // 执行单个操作
        onlyOneAction:function(actionItem, contentItemId){
            let action = {
                [GridAction.BatchCreate]: this.batchCreateContentItems,
                [GridAction.BatchUpdate]: this.batchUpdateContentItems,
                [GridAction.BatchPrint]: this.batchPrint,
            }

            action[actionItem.Type](actionItem, contentItemId);
        },

        

        // 新建Map数据源
        newDataSource:async function(dataSourceSetting){
			let values = [];
            values = await readContentItems(dataSourceSetting.ContentType,[dataSourceSetting.Label, dataSourceSetting.Value],0,0);
			return values.Result.data.map(x=> {
                return {
                    text: x[dataSourceSetting.Label],
                    value: x[dataSourceSetting.Value]
                }
            });
		},

        // 执行单个操作
        singleAction:function(actionContext, dataItemId){
            let action = {
                [SingleAction.Print]: this.singlePrint,
                [SingleAction.OpenDrawer]: this.singleOpenDrawer,
                [SingleAction.RequestWorkFlow]: this.singleRequestWorkFlow,
                [SingleAction.CreateContent]: this.singleCreateContent,
                [SingleAction.UpdateContent]: this.singleUpdateContent,
                [SingleAction.OpenGrid]: this.singleOpenGrid
            }
            action[actionContext.ActionType](actionContext, dataItemId)
        },

        /**
         * 单条打印
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        singlePrint:function(actionContext, dataItemId){
            window.open(this.$store.state.baseUrl + "/Qwe.ContentFlow.Print/Print/Index?TemplateId="+ actionContext.Print.Url + "&DataId=" + dataItemId, "_blank")
        },

        /**
         * 打开一个自定义页面
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        singleOpenDrawer:function(actionContext, dataItemId){
            this.printItem.title = actionContext.ButtonName;
            this.printItem.url = this.$store.state.baseUrl + "/Qwe.ContentFlow.Print/Print/Index?TemplateId="+ actionContext.Print.Url + "&DataId=" + dataItemId;
            this.printItem.visibleState = true;
        },

        /**
         * 请求工作流
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        singleRequestWorkFlow:async function(actionContext, dataItemId){
            if(actionContext.Workflow.Confirm){
                this.$messageBox.alert("你确定执行"+ actionContext.ButtonName +"操作吗？",actionContext.ButtonName,{
                    showCancelButton: true,
                    type: 'warning'
                }).then(x=>{
                    this.toRequestWorkflow(actionContext, dataItemId);
                }).catch(x=>{

                }) 
            }
            else{
                this.toRequestWorkflow(actionContext, dataItemId);
            }
        },

        /**
         * 执行工作流
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        toRequestWorkflow:function(actionContext, dataItemId){
            workFlowExe(actionContext.Workflow.WorkflowStartId, { DataId:dataItemId }).then(response=>{
                if(!qweIsEmpty(response.Result)){
                    this.$message.success(response.Result)
                }
                else{
                    this.$message.success(actionContext.ButtonName)
                }
                if(actionContext.Workflow.FlushData){
                    this.fetchDataSource();
                }
            }).catch(error=>{
                this.$message.error("操作失败，系统异常");
            })
        },

        /**
         * 创建一条新类型的内容项
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        singleCreateContent:function(actionContext, dataItemId){
            this.getSelectItems(dataItemId)
                .then(x=>{
                    let selectItem = x.Result.data[0];
                    this.context.Properties.Selects = x.Result.data;
                    this.context.Content = selectItem;
                    let item = actionContext.CreateContent;
                    if(this.batchCheckItems(item.CheckItems, this.context)){
                        this.createOtherItem.title = actionContext.ButtonName;
                        this.createOtherItem.operation = "Create";
                        this.createOtherItem.contentType = item.ContentType;
                        
                        this.createOtherItem.passingParameter = this.handlerPassingParameter(item.BatchFields);
                        this.createOtherItem.visibleState = true;
                    }
                })
        },

        /**
         * 更新当前类型内容项
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        singleUpdateContent:function(actionContext, dataItemId){
            actionContext.Update.ButtonName = actionContext.ButtonName;
            this.batchCreateContentItems(actionContext.Update, dataItemId);
        },

        /**
         * 打开一个自定义查询页面
         * @param { object } actionContext 当前动作上下文
         * @param { string } dataItemId 数据Id
         */
        singleOpenGrid:function(actionContext, dataItemId){
            this.getSelectItems(dataItemId).then(x=>{
                let selectItem = x.Result.data[0];
                this.context.Properties.Selects = x.Result.data;
                this.context.Content = selectItem;
                let script = actionContext.Grid.Script;
                let func = new Function("Context", "Content", script);
                let result = func(this.context, selectItem);
                let gridId = result.gridId;
                let filters = result.filters;


                this.gridItem.title = actionContext.ButtonName;
                this.gridItem.gridId = gridId;
                this.gridItem.filters = filters;
                this.gridItem.visibleState = true;
            })
        },
    }
}